import Flickity from "./vendor/flickity.pkgd.min.js";
import CHIPS_Scripts from "./_chips-scripts.js";
// import inView from "./vendor/in-view.min.js";

$("header button.menu-toggle").on("click", function () {
	$("body").toggleClass("menu-on");
});

$(".menu-panel-close").on("click", function () {
	$("body").removeClass("menu-on");
	$(".search-on").removeClass("search-on");
});

$(document).keyup(function (e) {
	if (e.key === "Escape") {
		$("body").removeClass("menu-on");
		$(".search-on").removeClass("search-on");
	}
});

function menuToggle() {
	// console.log("toggling menu");
	if ($("body").hasClass("menu-on")) {
		// console.log("removing menu-on");
		$("body").removeClass("menu-on");
		$(".search-on").removeClass("search-on");
	} else {
		// console.log("adding menu-on");
		$("body").addClass("menu-on");
	}
}

$(".search-close").on("click", function (e) {
	e.preventDefault();
	// console.log("toggling search close");
	$(".search-on").removeClass("search-on");
});

$(".accordion-toggle").on("click", function () {
	$(this).parent().toggleClass("accordion-on");
});

$(".hovTarget").hover(
	function () {
		$(this).closest(".hovParent").addClass("hovered");
	},
	function () {
		$(this).closest(".hovParent").removeClass("hovered");
	}
);
$(".hovParent a").hover(
	function () {
		$(this).closest(".hovParent").addClass("hovered");
	},
	function () {
		$(this).closest(".hovParent").removeClass("hovered");
	}
);
$(".readmore-toggle").on("click", function () {
	$(this).closest(".wyg").find(".readmore-content").addClass("vis");
	$(this).remove();
});

if ($(".rand-bg").hasClass("rand-bg")) {
	setRandCaption();
	$(window).resize(setRandCaption);
}
function setRandCaption() {
	var currW = $(".rand-bg.active img").width();
	if (currW > 0) {
		$(".rand-bg.active .img-caption").attr(
			"style",
			"max-width:" + currW + "px; opacity:1;"
		);
	}
}

import { carousels } from "./_chips-carousels.js";
carousels();

function updateClasses(instance, wrapdom) {}

if ($(".iv").hasClass("iv")) {
	inView.offset({
		bottom: 100,
	});
	inView(".iv").on("enter", function (el) {
		el.classList.add("vis");
	});
}

$(".js-filters a").on("click", function (e) {
	e.preventDefault();
	var newSlug = $(this).attr("href");
	if ($(this).parent().hasClass("filter-reset")) {
		$("body").removeClass("tab-internal");
		$(".js-filters .active").removeClass("active");
		$(".filter-target").removeClass("filtered");
		$(".filter-active").removeClass("filter-active");
		$(".tax-img").removeClass("active");
		$(this).parent().addClass("active");
		$("body").removeClass("filters-active");
	} else {
		setTimeout(function () {
			$("body").addClass("tab-internal");
		}, 500);
		if ($(this).parent().hasClass("active")) {
			$(".js-filters .active").removeClass("active");
			$(".filter-target").removeClass("filtered");
			$(".filter-active").removeClass("filter-active");
			$(".tax-img").removeClass("active");
			$(".filter-reset").addClass("active");
			$("body").removeClass("filters-active");
		} else {
			var filterCat = $(this).data("cat");
			$(".js-filters .active").removeClass("active");
			$(".filter-active").removeClass("filter-active");
			$(".tax-img").removeClass("active");
			$(this).parent().addClass("active");
			$(".filter-target").addClass("filtered");
			$(".cat-" + filterCat).addClass("filter-active");
			$(".tax-img-" + filterCat).addClass("active");
			$("body").addClass("filters-active");
		}
	}
	randomFilterImg();
	// console.log(newSlug);
	window.history.pushState({ slug: newSlug, pageTitle: null }, "", newSlug);
});

window.onpopstate = function (e) {
	$(".js-filters .active").removeClass("active");
	$(".filter-target").removeClass("filtered");
	$(".filter-active").removeClass("filter-active");
	$(".tax-img").removeClass("active");
	if (e.state) {
		if (
			e.state.slug.includes("essays-and-biographies") ||
			e.state.slug.includes("/works/")
		) {
			$(".js-filters a").each(function () {
				if ($(this).attr("href") === e.state.slug) {
					var filterCat = $(this).data("cat");
					$(".js-filters .active").removeClass("active");
					$(".filter-target .filter-active").removeClass(
						"filter-active"
					);
					$(this).parent().addClass("active");
					$(".filter-target").addClass("filtered");
					$(".filter-target .cat-" + filterCat).addClass(
						"filter-active"
					);
					$("body").removeClass("filters-active");
				}
			});
		}
	}
};

$(".gallery-random-wrap").each(function () {
	var locThis = $(this);
	randpool.sort(() => 0.5 - Math.random());
	if (randpool.length > 1) {
		$(".gallery-random-single").eq(0).html(randpool[0]);
		$(".gallery-random-single").eq(1).html(randpool[1]);
		setTimeout(function () {
			locThis.addClass("contents-loaded");
		}, 500);
	}
});

function randomFilterImg() {
	$(".tax-img .img-active").removeClass("img-active");
	$(".tax-img.active").each(function () {
		var imgPool = $(this).find(".gallery-random-single-tax");
		var scopeThis = $(this);
		if (imgPool.length > 0) {
			imgPool.sort(() => 0.5 - Math.random());
			scopeThis.find(imgPool[0]).addClass("img-active");
			if (imgPool.length > 1) {
				scopeThis.find(imgPool[1]).addClass("img-active");
			}
		}
	});
}
randomFilterImg();
